import { useState, useContext, useEffect } from "react";
//import './Register.css'; // Optional, for specific styles
import { Link } from "react-router-dom";
import AlertMessage from "../../components/AlertMessage";
import useResetPassword from "../../hooks/useResetPassword";

const ResetPassword = () => {
  const {
    email,
    submitToReset,
    message,
    setShowMessage,
    showMessage,
    config,
    loading,
  } = useResetPassword();

  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  function validatePassword(value) {
    const lower = /[a-z]/.test(value);
    const upper = /[A-Z]/.test(value);
    const symbol = /[^a-zA-Z0-9]/.test(value);
    const length = value.length >= 8 && value.length <= 20;

    return lower && upper && symbol && length;
  }
  const validate = () => {
    const newErrors = {
      password: "",
      confirmPassword: "",
    };
    var flag = true;

    if (!(form.password.length >= 8 && form.password.length <= 20)) {
      newErrors.password = "Password too short.";
      flag = false;
    }

    if (!validatePassword(form.password)) {
      newErrors.password = "Must include: uppercase, lowercase, symbol.";
      flag = false;
    }

    if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      flag = false;
    }

    setErrors(newErrors);
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await submitToReset(form.password);
  };

  if (config) {
    return (
      <div className="d-flex justify-content-center h-100">
        <div className="d-flex align-items-center">
          <div className="login-card row g-0 shadow-lg">
            <div className="row g-0">
              <div className="col-md-6 image-side">
                <div>
                  <h2>Find your sweet home</h2>
                  <p>
                    Schedule visits in just a few clicks.
                    <br />
                    Your dream property awaits.
                  </p>
                </div>
              </div>

              <div className="col-md-6 d-flex align-items-center justify-content-center form-side">
                <div className="w-100">
                  <div className="w-100">
                    <p>
                      {showMessage && (
                        <AlertMessage
                          key={message.text}
                          setVisible={setShowMessage}
                          message={message.text}
                          type={message.type}
                          duration={4000}
                        />
                      )}
                    </p>
                  </div>
                  <h4 className="login-title mb-2 text-color">
                    Reset your password
                  </h4>
                  <h6>set a new password</h6>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label for="email" className="form-label ">
                        Email
                      </label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="form-control"
                        value={email}
                        disabled
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        name="password"
                        className={`form-control ${
                          errors.password && "is-invalid"
                        }`}
                        value={form.password}
                        onChange={handleChange}
                      />
                      {errors.password && (
                        <div className="invalid-feedback">
                          {errors.password}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        name="confirmPassword"
                        className={`form-control ${
                          errors.confirmPassword && "is-invalid"
                        }`}
                        value={form.confirmPassword}
                        onChange={handleChange}
                      />
                      {errors.confirmPassword && (
                        <div className="invalid-feedback">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="btn btn-dark w-100 mb-3"
                      disabled={loading}
                    >
                      Reset
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    <div>Loading...</div>;
  }
};

export default ResetPassword;
